import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { RegistrationApi, type ResendCodeResponse } from '@shared/api';
import { AuthUtils } from '@shared/utils';

const resendCodeEffect = createEffect(() => RegistrationApi.resendCode());
const clearEvent = createEvent();

const $dataStore = createStore<ResendCodeResponse | null>(null)
  .on(resendCodeEffect.done, (_, data) => {
    AuthUtils.setToken('resendCodeToken', data.result.data?.token);
    return data.result.data || null;
  })
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(resendCodeEffect.pending, (_, data) => data)
  .on(resendCodeEffect.fail, () => false)
  .on(resendCodeEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(resendCodeEffect, () => null)
  .on(resendCodeEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(resendCodeEffect.done, () => null)
  .reset(clearEvent);

export const $resendCodeStore = {
  events: {
    resendCode: resendCodeEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
